import { useEffect, useState } from "react";
import { useRef } from "react";
import SubMenu from "./SubMenu";
import { motion } from "framer-motion";

// * React icons
import { IoIosArrowBack } from "react-icons/io";
import { SlSettings } from "react-icons/sl";
// import { AiOutlineAppstore } from "react-icons/ai";
import { BsPerson } from "react-icons/bs";
import { HiOutlineDatabase } from "react-icons/hi";
import { TbReportAnalytics } from "react-icons/tb";
import { RiBuilding3Line } from "react-icons/ri";
import { useMediaQuery } from "react-responsive";
import { MdMenu } from "react-icons/md";
import { NavLink, useLocation, useRoutes } from "react-router-dom";
import { useSelector } from "react-redux";

const Sidebar = ({
  Nav_animation,
  open,
  setOpen,
  sidebarRef,
  pathname,
  isTabletMid,
  items,
}) => {
  const { totalUnreadCount } = useSelector((state) => state.AdminChatReducer);

  const { setupDetails } = useSelector((state) => state.SetupReducer);
  const subMenusList = [
    {
      name: "build",
      icon: RiBuilding3Line,
      menus: ["auth", "app settings", "stroage", "hosting"],
    },
    {
      name: "analytics",
      icon: TbReportAnalytics,
      menus: ["dashboard", "realtime", "events"],
    },
  ];

  return (
    <div>
      <div
        onClick={() => setOpen(false)}
        className={`md:hidden fixed inset-0 max-h-screen z-[998] bg-black/50 ${
          open ? "block" : "hidden"
        } `}
      ></div>
      <motion.div
        ref={sidebarRef}
        variants={Nav_animation}
        initial={{ x: isTabletMid ? -250 : 0 }}
        animate={open ? "open" : "closed"}
        className="bg-white text-gray shadow-xl z-[999] max-w-[16rem] w-[16rem] md:relative fixed h-screen flex flex-col"
      >
        <div className="flex items-center justify-between gap-3 font-medium border-b py-3 border-slate-300 mx-3">
          <div className="flex items-center gap-3">
            {setupDetails?.logo && (
              <img
                src={setupDetails.logoPath + setupDetails.logo}
                alt="Uploaded Logo"
                className=" w-11"
              />
            )}
            {open && (
              <span className="text-xl font-bold p-font-style whitespace-pre text-black my-auto mt-1">
                {setupDetails && setupDetails?.name}
              </span>
            )}
          </div>
          <motion.div
            animate={
              open
                ? {
                    x: 0,
                    rotate: 0,
                    opacity: 1,
                  }
                : {
                    x: 0,
                    rotate: 180,
                    opacity: 1,
                  }
            }
            transition={{ duration: 0.2 }}
            className="relative md:block hidden cursor-pointer"
            onClick={() => setOpen(!open)}
          >
            <div className="flex items-center justify-center w-full h-full">
              <IoIosArrowBack size={20} />
            </div>
          </motion.div>
        </div>

        <div className="flex-1 overflow-hidden">
          <ul
            className={`whitespace-pre ${
              open ? "px-2.5" : "px-1"
            } text-[0.9rem] py-5 flex flex-col gap-1 font-medium overflow-y-auto h-full`}
          >
            {items.map((link, index) =>
              link.showInSidebar ? (
                <li key={index}>
                  <NavLink
                    to={link.path}
                    className={`link relative flex ${
                      open ? "justify-between" : "justify-center"
                    } items-center`}
                  >
                    <div className="flex items-center gap-2">
                      <link.icon size={23} className="min-w-max" />
                      {open && <span>{link.name}</span>}
                    </div>
                    {link.name === "Customer Live Chat" &&
                      totalUnreadCount > 0 &&
                      open && (
                        <span className="absolute right-2 text-red bg-red-500 rounded-full w-5 h-5 flex items-center justify-center">
                          {totalUnreadCount}
                        </span>
                      )}
                  </NavLink>
                </li>
              ) : null
            )}

            {/* <li>
              <NavLink to={"/authentication"} className="link">
                <BsPerson size={23} className="min-w-max" />
                Authentication
              </NavLink>
            </li>
            <li>
              <NavLink to={"/stroage"} className="link">
                <HiOutlineDatabase size={23} className="min-w-max" />
                Stroage
              </NavLink>
            </li> */}

            {/* {(open || isTabletMid) && (
              <div className="border-y py-5 border-slate-300 ">
                <small className="pl-3 text-slate-500 inline-block mb-2">
                  Product categories
                </small>
                {subMenusList?.map((menu) => (
                  <div key={menu.name} className="flex flex-col gap-1">
                    <SubMenu data={menu} />
                  </div>
                ))}
              </div>
            )}
            <li>
              <NavLink to={"/settings"} className="link">
                <SlSettings size={23} className="min-w-max" />
                Settings
              </NavLink>
            </li> */}
          </ul>
          {/* {open && (
            <div className="flex-1 text-sm z-50  max-h-48 my-auto  whitespace-pre   w-full  font-medium  ">
              <div className="flex border-y border-slate-300 p-4 items-center justify-between">
                <div>
                  <p>Spark</p>
                  <small>No-cost $0/month</small>
                </div>
                <p className="text-teal-500 py-1.5 px-3 text-xs bg-teal-50 rounded-xl">
                  Upgrade
                </p>
              </div>
            </div>
          )} */}

          {/* Add the collapse button here, after the menu items */}
        </div>
      </motion.div>
      {/* <div className="m-3 md:hidden  " onClick={() => setOpen(true)}>
        <MdMenu size={25} />
      </div> */}
    </div>
  );
};

export default Sidebar;
